__turbopack_context__.v({
  "DistributorCardList__Container": "ttM5Ba_DistributorCardList__Container",
  "DistributorCardList__Item": "ttM5Ba_DistributorCardList__Item",
  "DistributorCardList__List": "ttM5Ba_DistributorCardList__List",
});
